import {
  SelectionSheet,
  Icon,
  getTranslatedText,
  BackgroundIcon
} from '@nile/components';
import { Sheet, Button } from '@superops/ui-design-system';
import { cloneDeep } from 'lodash';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage, injectIntl } from 'react-intl';

const Field = styled.div`
  button.Polaris-Link,
  .Superops-Button--plain {
    // padding: 10px 12px;
    font-weight: normal;
  }
  .memberCount {
    font-weight: 500;
  }
`;

function EmployeesPicker(props) {
  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = useCallback(
    () => setSheetActive((val) => !val),
    []
  );
  const { intl, allUsers, selectedItems, icon } = props;
  let itemsSelected = selectedItems && cloneDeep(selectedItems);
  if (selectedItems) {
    itemsSelected = cloneDeep(selectedItems).map((item) => {
      const user = item;
      user.id = user.userId;
      return user;
    });
  }

  const sections = [];
  const userSection = {
    name: 'user',
    header: getTranslatedText(
      intl,
      'ticket.newProject.details.choosemembers.allemp'
    ),
    items: allUsers.map((el) => {
      return {
        ...el,
        id: el.userId,
        name: el.name,
        label: `${el.firstName} ${el.lastName}`
      };
    })
  };
  sections.push(userSection);
  const updateParent = (selectedItem) => {
    props.updateUserList(selectedItem);
  };

  const setSelectableValues = (arr) => {
    if (arr?.length) {
      return arr.map((item) => {
        const user = { ...item };
        user.label = `${user.firstName} ${user.lastName}`;
        return user;
      });
    }
  };

  return (
    <div>
      <Field className="flex actr" data-qa="associateBtn">
        <Button onClick={toggleSheetActive} plain monochrome icon={props?.icon}>
          {props?.btnText ? (
            <div className="memberCount">{props.btnText}</div>
          ) : (
            <div>
              <FormattedMessage id="ticket.newProject.details.choosemembers.header" />
            </div>
          )}
        </Button>
      </Field>
      <Sheet open={sheetActive} onClose={toggleSheetActive}>
        <SelectionSheet
          sections={sections}
          actions={props.actions}
          meta={{
            heading:
              props.heading ||
              getTranslatedText(
                intl,
                'ticket.newProject.details.choosemembers.header'
              ),
            selectedTitle:
              props.selectedTitle ||
              getTranslatedText(
                intl,
                'ticket.newProject.details.choosemembers.select'
              )
          }}
          data={allUsers}
          selectedItems={setSelectableValues(itemsSelected)}
          toggleSheetActive={toggleSheetActive}
          updateParent={updateParent}
        />
      </Sheet>
    </div>
  );
}

export default injectIntl(EmployeesPicker);
